import { Button, Flex, PaginationPerPageSelect } from 'dash-ui';
import styled from 'styled-components';

export const FlexWraper = styled(Flex)`
  flex-direction: row;
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 5px;
  }
`;

export const PaginationPerPageSelectWrap = styled(PaginationPerPageSelect)`
  margin-left: 4px;
  @media ${({ theme }) => theme.devices.mobile} {
    margin: 0;
  }
`;

export const ButtonWrap = styled(Button)`
  @media ${({ theme }) => theme.devices.mobile} {
    margin: 0;
    margin-top: 5px;
  }
`;
